import api from "./api/api";

var resCode = require("../server/common/data").resCode;

// doRegister
export const doRegister = (that, data) => {
  api
    .register(data)
    .then(res => {
      let code = res.data.CODE;
      if (code === resCode.SUCCESS) {
        showMsg(that, true, that.$t('signup.registerSuccess'), "success");
        that.$router.push({ path: "/login" });
      } else if (code === resCode.VERIFY_CODE_MISMATCH) {
        showMsg(that, true, that.$t('common.veriryCodeMismatch'), "error");
      } else if (code === resCode.EMAIL_ALREADY_EXIST) {
        showMsg(that, true, that.$t('signup.emailUsed'), "error");
      } else if (code === resCode.USERNAME_ALREADY_EXIST) {
        showMsg(that, true, that.$t('signup.usernameUsed'), "error");
      } else { // INVALID_RECAPTCHA
        showMsg(that, true, that.$t('common.tyrLater'), "error");
      }
    })
    .catch(err => {
      console.log(err);
    });
};

// changePassword
export const changePassword = (that, data) => {
  api
    .changePassword(data)
    .then(res => {
      let code = res.data.CODE;
      if (code === resCode.SUCCESS) {
        showMsg(that, true, that.$t('changePwd.changeSuccess'), "success");
      } else if (code === resCode.USER_PASSWORD_MISMATCH) {
        showMsg(that, true, that.$t('changePwd.oldPwdIncorrect'), "error");
      }
    })
    .catch(err => {
      console.log(err);
    });
};

// changeEmail
export const changeEmail = (that, data) => {
  api
    .changeEmail(data)
    .then(res => {
      let code = res.data.CODE;
      if (code === resCode.SUCCESS) {
        showMsg(that, true, that.$t('changeEmail.changeSuccess'), "success");
      } else if (code === resCode.VERIFY_CODE_MISMATCH) {
        showMsg(that, true, that.$t('common.veriryCodeMismatch'), "error");
      } else if (code === resCode.EMAIL_ALREADY_EXIST) {
        showMsg(that, true, that.$t('signup.emailUsed'), "error");
      } else if (code === resCode.USER_PASSWORD_MISMATCH) {
        showMsg(that, true, that.$t('changeEmail.pwdIncorrect'), "error");
      }
    })
    .catch(err => {
      console.log(err);
    });
};

// sendVerifyCode
export const sendVerifyCode = (that, data) => {
  api
    .getVerifyCode(data)
    .then(res => {
      let code = res.data.CODE;
      if (code === resCode.SUCCESS) {
        showMsg(that, true, that.$t('common.sendCodeSuccess'), "success");
      } else if (code === resCode.VERIFY_CODE_SENT) {
        showMsg(that, true, that.$t('common.codeSent'), "info");
      } else if (code === resCode.SEND_VERIFY_CODE_FAIL) {
        showMsg(that, true, that.$t('common.sendCodeFail'), "error");
      } else if (code === resCode.USER_NOT_FOUND) {
        showMsg(that, true, that.$t('common.emailNotRegister'), "error");
      }
    })
    .catch(err => {
      console.log(err);
    });
};

// resetPassword
export const resetPassword = (that, data) => {
  api
    .resetPassword(data)
    .then(res => {
      let code = res.data.CODE;
      if (code === resCode.SUCCESS) {
        showMsg(that, true, that.$t('resetPwd.mailReminder'), "info");
        that.$router.push({ path: "/login" });
      } else if (code === resCode.VERIFY_CODE_MISMATCH) {
        showMsg(that, true, that.$t('common.veriryCodeMismatch'), "error");
      } else if (code === resCode.USER_NOT_FOUND) {
        showMsg(that, true, that.$t('common.emailNotRegister'), "error");
      } else { // SEND_VERIFY_CODE_FAIL or UNKNOWN_ERROR
        showMsg(that, true, that.$t('common.tyrLater'), "error");
      }
    })
    .catch(err => {
      console.log(err);
    });
};

// 显示提示框
export const showMsg = (that, close, msg, type) => {
  that.$message({
    showClose: close,
    message: msg,
    type: type
  });
};

// doLogin
export const doLogin = (that, data) => {
  api
    .login(data)
    .then(res => {
      if (res.data.CODE === resCode.SUCCESS) {
        sessionStorage.setItem("login", "true");
        sessionStorage.setItem("role", res.data.DATA.role);
        if (res.data.DATA.role === "admin") {
          that.$router.push({name: "Users"});
        } else {
          that.$router.push({name: "Project Management"});
        }
      } else if (res.data.CODE === resCode.USER_PASSWORD_MISMATCH) {
        showMsg(that, true, that.$t('login.incorrectPwd'), "error");
      } else if (res.data.CODE === resCode.ACCOUNT_ABNORMAL) {
        showMsg(that, true, that.$t('login.accountAbnormal'), "error");
      }  else { // INVALID_RECAPTCHA
        showMsg(that, true, that.$t('common.tyrLater'), "error");
      }
    })
    .catch(err => {
      console.log(err);
    });
};

// logout
export const doLogout = (that, data) => {
  api
    .logout(data)
    .then(res => {
      sessionStorage.setItem("login", "false");
      sessionStorage.removeItem('role');
      that.$router.push("/login");
    })
    .catch(err => {
      console.log(err);
    });
};



// WEBPACK FOOTER //
// ./src/request.js